import { assertUnreachable } from '@dreryk/react-common';

const DOCPLANNER_SOURCE_LABEL = 'ZnanyLekarz';
const PATIENT_PORTAL_SOURCE_LABEL = 'patient-portal';
const WAITLIST_SOURCE_LABEL = 'waitlist';

export const getDocplannerAvailabilityLabel = (): typeof DOCPLANNER_SOURCE_LABEL => DOCPLANNER_SOURCE_LABEL;
export const getPatientPortalAvailabilityLabel = (): typeof PATIENT_PORTAL_SOURCE_LABEL => PATIENT_PORTAL_SOURCE_LABEL;
export const getWaitlistLabel = (): typeof WAITLIST_SOURCE_LABEL => WAITLIST_SOURCE_LABEL;

export type SourceLabelType = 'docplanner' | 'patient-portal' | 'waitlist';

export const hasCollectionSourceLabel = (
   collection: Array<string>,
   sourceLabelType: SourceLabelType
): collection is Array<typeof DOCPLANNER_SOURCE_LABEL> => {
   switch (sourceLabelType) {
      case 'docplanner':
         return collection.includes(DOCPLANNER_SOURCE_LABEL);
      case 'patient-portal':
         return collection.includes(PATIENT_PORTAL_SOURCE_LABEL);
      case 'waitlist':
         return collection.includes(WAITLIST_SOURCE_LABEL);
      default:
         return assertUnreachable(sourceLabelType);
   }
};
